export default __webpack_public_path__ + "images/trial03.svg";